<div class="login_content">
	<!-- PÁGINA  -->
	<div class="page">
		<!-- Header -->
		<app-header></app-header>
		<!-- <app-loader></app-loader> -->
		<!-- Fin Header -->

		<!-- Contenidos -->
		<div class="content-wrap">
			<div class="central-wrapper clearfix">
				<div class="left_login">
					<div class="logo_login">
						<img src="assets/images/logo_cp.svg" alt="Cooperativa Pacifico" />
					</div>
					<h1>Bienvenido a <strong>Pacinet</strong></h1>

					<div class="img_login">
						<img src="assets/images/familia-pacifico.png" alt="Familia Cooperativa Pacifico" />
					</div>
				</div>
				<ng-content> </ng-content>
				<app-alert [isSnackBar]="true"></app-alert>
			</div>

			<!-- fin Contenidos -->

			<!-- F O O T E R -->
			<app-footer></app-footer>
			<!-- F I N  F O O T E R -->
		</div>
	</div>
</div>
